let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7fFQf")).then(() => parcelRequire('fkf6J'));